<template>
  <div class="checkbox-group">
    <m4-label v-if="labelAbove" :for="$attrs.id" :error="!!error" class="checkbox-group__label-above">
      {{ labelAbove }}
    </m4-label>
    <div class="checkbox-group__checkbox-wrapper" v-for="(option, index) in options" :key="index">
      <m4-checkbox
        :native-value="getOptionValue(option)"
        :name="name"
        v-model="checkedOptions"
        class="checkbox-group__checkbox-wrapper__checkbox"
        :disabled="option.disabled != undefined && option.disabled"
      >
        <span v-html="getOptionLabel(option)"></span>
      </m4-checkbox>
      <m4-form-field
        v-if="showTextField(option)"
        :type="customFieldType"
        :name="getTextFieldName"
        :placeholder="customFieldPlaceholder"
        :value="customFieldValue"
      ></m4-form-field>
    </div>
  </div>
</template>

<script>
import callExternalFunction from "../../../utils/callExternalFunction";

export default {
  name: "M4CheckboxGroup",
  mixins: [callExternalFunction],
  data() {
    return {
      newValue: this.modelValue && this.modelValue.length > 0 ? this.modelValue : this.value ? this.value : []
    };
  },
  props: {
    name: String,
    customFieldType: {
      type: String,
      default: "text"
    },
    customFieldPlaceholder: {
      type: String,
      default: ""
    },
    customFieldName: {
      type: String
    },
    customFieldValue: {
      type: String,
      default: ""
    },
    error: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Array],
      default() {
        return [];
      }
    },
    modelValue: {
      type: [Array],
      default() {
        return [];
      }
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    multiple: {
      type: Boolean,
      default() {
        return true;
      }
    },
    labelAbove: String
  },
  emits: ["update:modelValue", "init"],
  mounted() {
    this.$emit("init", this.newValue);
  },
  computed: {
    checkedOptions: {
      get() {
        return this.newValue;
      },
      set(value) {
        if (!this.multiple) {
          if (this.newValue && value) {
            if (this.newValue.length < value.length) {
              value = [value[value.length - 1]];
            } else {
              value = [];
            }
          }
        }

        this.newValue = value;
        this.$emit("update:modelValue", value);
        this.callExtFunc("updateModelValue", value);
      }
    },
    getTextFieldName() {
      let name = this.name.replace("[]", "") + "__text";
      if (this.customFieldName) {
        name = this.customFieldName;
      }
      return name;
    }
  },
  methods: {
    getOptionValue(option) {
      if (typeof option === "object") {
        return option.value;
      }
      return option;
    },
    getOptionLabel(option) {
      if (typeof option === "object") {
        return option.label;
      }
      return option;
    },
    showTextField(option) {
      return typeof option === "object" && option.textfield && this.newValue.indexOf(option.value) >= 0;
    }
  },
  watch: {
    modelValue(value) {
      this.newValue = value;
    },
    value(value) {
      this.newValue = value;
    }
  }
};
</script>
